import React from 'react'
import styled from 'styled-components'
import { screenSize } from 'styles/shared'
import { color } from 'styles/colors'

import sampleQuestions from 'pages/Chatbot/SampleQuestions'
import Chatbot from 'components/Chatbot'
import GA4 from 'helpers/ga4'

type Props = {
  remainingMessageCount: number | undefined
  handleToggleChats: (message?: string) => void
  className?: string
}

const ChatHome = ({ remainingMessageCount, handleToggleChats, className }: Props) => {
  const handleSampleQuestionClick = (question: string) => {
    GA4.sendEvent({ category: 'Chat Bot', action: 'Chat Bot Sample Question', label: question })
    handleToggleChats(question)
  }

  return (
    <S.Container className={className}>
      <S.ChatBox>
        <S.Heading><span>How can I help?</span></S.Heading>
        <S.SearchBox>
          <Chatbot remainingMessageCount={remainingMessageCount} isChatHome handleToggleChats={handleToggleChats} />
        </S.SearchBox>

        <S.QuestionList>
          <S.Label>For Example:</S.Label>
          {sampleQuestions.map((question) => (
            <S.Question key={question} onClick={() => handleSampleQuestionClick(question)}>{question}</S.Question>
          ))}
        </S.QuestionList>
      </S.ChatBox>
    </S.Container>
  )
}

export default ChatHome

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const S = {
  Container: styled.div`    
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background: ${color('chatbotBackground')};
  `,
  ChatBox: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 40px;
    padding: 40px;
    border-width: 2px;
    border-style: solid;
    width: 860px;
    height: 446px;
    border-radius: 20px;
    background: linear-gradient(${color('chatbotBackground')}, ${color('chatbotBackground')}) padding-box,
              linear-gradient(to right, ${color('chatbotChatBoxGradientBorder')}, ${color('chatbotChatBoxBorder')}) border-box;

    border: 1px solid transparent;
  
    @media (${screenSize.medium}) {
      width: 450px;
      height: 450px;
    }

    @media (${screenSize.small}) {
      width: 325px;
      height: 480px;
    }
  
  `,
  Heading: styled.div`
    color: ${color('chatbotText')};
    font-weight: 700;
    font-size: 40px;
    text-align: center;

    @media (${screenSize.small}) {
      font-size: 30px;
    }
  `,
  SearchBox: FlexColumn,
  Question: styled.button`
    color: ${color('chatbotQuestion')};
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    text-align: left;
    font: inherit;

    &:hover {
      text-decoration: underline;
    }
  `,
  QuestionList: FlexColumn,
  Label: styled.span`
    font-size: 14px;
    font-weight: 400;
    font-style: italic;
    color: ${color('chatbotInfoText')};
  `
}
